import React from "react";
import {
  Form,
  FormElement,
  FormValidator,
  CustomTextControl,
  BaseReactComponent,
  FormSubmitButton,
} from "../../utils/form";
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "../../utils/hoc/withRouter";
import { CustomModal, Spinner, SelectKeywords } from "../common";
import { addColorApi, updateColorApi, getKeywordNameApi } from "./Api";
import { toast } from "react-toastify";

class ColorForm extends BaseReactComponent {
  constructor(props) {
    super(props);
    const data = props.editData || null;
    this.state = {
      isAddContent: true,
      colorName: data?.colorName || "",
      colorCode: data?.colorCode || "",
      keywords: data?.keywords ? data.keywords.split(",").map(item => item.trim()).filter(Boolean) : [],
      keywordOption: [],
      search: "",
      resLoading: false,
    };
  }

  componentDidMount() {
    this.props.getKeywordNameApi(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.search !== prevState.search) {
      this.props.getKeywordNameApi(this);
    }
  }

  keywordsChangeHandler = (info) => {
    this.setState({ search: info })
  }
  onValidSubmit = () => {
    this.setState({ resLoading: true })
    let data = {
      "data": {
        "colorName": this.state.colorName,
        "colorCode": this.state.colorCode.includes('#') ? this.state.colorCode : `#${this.state.colorCode}`,
        "keywords": this.state.keywords?.length > 0 ? this.state.keywords.join(",") : "",
      },
    };
    if (this.props.editData?.uuid) {
      updateColorApi(JSON.stringify(data), this.props.this, this.props.onHide, this.props.editData.uuid, this)
    } else {
      addColorApi(JSON.stringify(data), this.props.this, this.props.onHide, this);
    }

  };
  render() {
    return (
      <CustomModal
        show={this.props.show}
        onHide={this.props.onHide}
        title={this.props.editData?.uuid ? "Edit Color" : "Add Color"}
        modalClass={"change-password"}
      >
        <Form onValidSubmit={this.onValidSubmit}>
          <Row>
            <Col sm={12}>
              <FormElement
                valueLink={this.linkState(this, "colorName")}
                label="Name"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    //   type: "",
                    placeholder: "Enter Color Name",
                  },
                }}
              />
            </Col>
            <Col sm={12}>
              <FormElement
                valueLink={this.linkState(this, "colorCode")}
                label="Code"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    //   type: "",
                    placeholder: "Enter Color Code",
                  },
                }}
              />
            </Col>
            <Col sm={12}>
              <SelectKeywords
                required={false}
                label="Keywords"
                placeholder={'Enter Keywords'}
                onchangeHandler={(data) => this.keywordsChangeHandler(data)}
                selectedKeyWords={this.state.keywords}
                options={this.state.keywordOption}
                getKeys={(data) => this.setState({ keywords: data })}
              />
            </Col>
          </Row>
          <div className="submit-wrapper" style={{ justifyContent: "center" }}>
            <FormSubmitButton customClass={"primary-btn"}>
              {this.state.resLoading ? <span className="d-flex align-items-center gap-12"> <Spinner /> Saving...</span> : "Save"}
            </FormSubmitButton>
          </div>
        </Form>
      </CustomModal>
    );
  }
}

export default connect(null, { getKeywordNameApi })(withRouter(ColorForm));
